export default "__VITE_ASSET__CJrV2tGT__"